<p-toast></p-toast>

<p-dialog [visible]="isVisible()" (visibleChange)="close($event)" (onHide)="close(true)"
    header="Plantilla de resolución" [modal]="true" [draggable]="false" [resizable]="false" [closable]="false">
    <ng-template pTemplate="content">
        <div class="gap-1 pt-0 flex-wrap flex flex-column">
            <label for="templateDropdown" class="mb-2">Seleccione la plantilla</label>
            <p-dropdown id="templateDropdown" showError [options]="availableTemplates()" optionLabel="nombre"
                [required]="true" showClear="true" (onChange)="handleTemplateSelection($event)"
                [(ngModel)]="selectedTemplate" placeholder="Seleccione la plantilla" appendTo="body">
                <ng-template let-item pTemplate="item">
                    <div class="flex align-items-center" pTooltip="{{ item.descripcion || item.nombre }}"
                        tooltipPosition="right" [tooltipOptions]="{ showDelay: 500, hideDelay: 300 }">
                        <div>{{ item.nombre }}</div>
                    </div>
                </ng-template>
            </p-dropdown>

            @if(selectedTemplate()) {
            <span class="text-sm text-gray-500 mt-4">
                {{ selectedTemplate()?.descripcion }}
            </span>
            }
        </div>
    </ng-template>

    <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text p-button-secondary"
            (click)="close(true)"></button>


        <button pButton pRipple type="button" label="Descargar" icon="pi pi-download" class="p-button-primary"
            (click)="downloadSelectedTemplate()" [disabled]="!selectedTemplate()"></button>

    </ng-template>
</p-dialog>